import React from 'react';
import { func, oneOf, string } from 'prop-types';
import Button from '../Button';
import './styles.scss';
const InformationModal = ({ icon, status, onConfirm, message, title }) => {

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="false">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div>
            {status === 'warning' && <i className={`modal-icon ${icon}`}></i>}

            <h5 className="modal-title text-center">    {status === 'success' && <i className='title-icon fas fa-info-circle'></i>}{title}</h5>
          </div>
          <div className="modal-body p-0 mb-1">
          <p className="modal-message">{message}</p>
          </div>
          <div className="modal-actions m-0">
            <Button customStyles={{ minWidth: '120px', border: 'none' }} type="button" size="smaller" color={status} onClick={onConfirm} >Aceptar</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

InformationModal.propTypes = {
  onConfirm: func.isRequired,
  message: string,
  title: string,
  status: oneOf(['primary', 'warning', 'error', 'success']),
  icon: string
};

InformationModal.defaultProps = {
  status: 'success',
  message: 'Información',
  title: 'Información',
  icon: 'fas fa-exclamation-circle'
};

export default InformationModal;